// Index file for the directory. Don't add anything else here.
import CarouselSneakertimeSearch from './CarouselSneakertimeSearch';
export default CarouselSneakertimeSearch;
